import { Injectable } from '@angular/core';
import decode from 'jwt-decode';
@Injectable()
export class AuthService {

    public getToken(): string {
        return localStorage.getItem('activeToken');
    }

    public isAuthenticated(): boolean {
        const token = this.getToken();
        return token != null;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/auth/auth.service.ts